import api from '../..'
import { IAnswerTaskModel } from 'models/answerTask.model'
import { Attachment } from '../../../models/attachments.model'

const answerTaskCreate = (answerTask: IAnswerTaskModel) => {
  const data = { attachments: answerTask }
  return api.post<{data: { attributes: Attachment, id: number }[]}>('answers/attachments', data).then(({ data }) => data.data.map(({ attributes }) => attributes))
}

export default answerTaskCreate
